<template>
  <div class="relay-control-detail">
    <div class="content" v-if="isMuti">
      <div class="power" style="height: 110px">
        <div class="head">
          <div>KPB{{ $t("terminal.powerList") }}</div>
        </div>
        <div class="main" v-loading="cardLoading" style="height: 70px">
          <template>
            <div class="item" v-for="item in kpbPower" :key="item.name">
              <div class="contents">
                <div class="name">{{ $t(item.name) }}</div>
                <el-switch
                  v-model="item.value"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                >
                </el-switch>
                <span v-if="item.value">{{ $t("terminal.open") }}</span>
                <span v-else>{{ $t("terminal.close") }}</span>
              </div>
            </div>
          </template>
        </div>
      </div>

      <div class="power">
        <div class="head">
          <div>{{ $t("terminal.powerList") }}</div>
          <div>
            <el-button
              round
              size="mini"
              type="danger"
              @click="allOpen('power', false)"
              >{{ $t("terminal.allClose") }}</el-button
            >
            <el-button
              round
              size="mini"
              type="success"
              @click="allOpen('power', true)"
              >{{ $t("terminal.allOpen") }}</el-button
            >
          </div>
        </div>
        <div class="main" v-loading="cardLoading">
          <template>
            <div class="item" v-for="item in powerList" :key="item.name">
              <div class="contents">
                <div class="name">{{ $t(item.name) }}</div>
                <el-switch
                  v-model="item.value"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                >
                </el-switch>
                <span v-if="item.value">{{ $t("terminal.open") }}</span>
                <span v-else>{{ $t("terminal.close") }}</span>
              </div>
            </div>
          </template>
        </div>
      </div>
      <div class="power" style="height: 350px">
        <div class="head">
          <div>{{ $t("terminal.mulCard") }}</div>
          <div>
            <el-button
              round
              size="mini"
              type="danger"
              @click="allOpen('card', false)"
              >{{ $t("terminal.allClose") }}</el-button
            >
            <el-button
              round
              size="mini"
              type="success"
              @click="allOpen('card', true)"
              >{{ $t("terminal.allOpen") }}</el-button
            >
          </div>
        </div>
        <div class="main card-main" v-loading="cardLoading">
          <template>
            <div class="item" v-for="item in cardList" :key="item.name">
              <div class="contents">
                <div class="name">{{ $t(item.name) }}</div>
                <el-switch
                  v-model="item.value"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                >
                </el-switch>
                <span v-if="item.value">{{ $t("terminal.open") }}</span>
                <span v-else>{{ $t("terminal.close") }}</span>
              </div>
            </div>
          </template>
        </div>
      </div>
      <el-button
        @click="refreshStatus"
        round
        size="mini"
        type="primary"
        class="refresh"
        :disabled="currentDetail.run_state == 0 || isBan"
        >{{ $t("terminal.refresh") }}</el-button
      >
      <el-button
        @click="sendToDevice"
        round
        size="mini"
        type="primary"
        class="button"
        :disabled="currentDetail.run_state == 0 || isBan"
        >{{ $t("terminal.syncToTerminal") }}</el-button
      >
    </div>
    <div v-else class="single">
      <div>{{ $t("terminal.mulCard") }}</div>
      <div class="multi">
        <el-button type="primary" @click="controlNoVersion('open')" round>{{
          $t("terminal.allOpen")
        }}</el-button>
        <el-button type="danger" @click="controlNoVersion('close')" round>{{
          $t("terminal.allClose")
        }}</el-button>
      </div>
    </div>
    <form-dialog
      :dialogVisible="dialogVisible"
      @closeDialog="closeFormDialog"
      :isAppend="true"
    >
      <div
        style="width: 100%; text-align: center; font-size: 18px; height: 24px"
      >
        {{ $t("terminal.allOpenTip") }}
      </div>
    </form-dialog>
  </div>
</template>

<script>
//const generalCommand = "/admin/command/generalCommand";
import {
  uriEncode
} from "@/assets/scripts/uriEncode";
import {
  sendCommandKp
} from "@/assets/scripts/publicFunction";
import FormDialog from "@/components/basics/DelDialogConfirm";
export default {
  name: 'RelayControlDetail',
  props: {
    currentDetail: {
      type: Object
    }
  },
  components: {
    FormDialog
  },
  data() {
    return {
      dcInfoCache: [],
      kpbPower: [{
        name: "terminal.firstChannel",   //0-没操作1-开2-关
        value: 0
      }],
      powerList: [{
        name: 'terminal.firstChannel',
        value: false
      }, {
        name: 'terminal.secondChannel',
        value: false
      }, {
        name: 'terminal.thirdChannel',
        value: false
      }],
      cardList: [{
        name: 'terminal.firstChannel',
        value: false
      }, {
        name: 'terminal.secondChannel',
        value: false
      }, {
        name: 'terminal.thirdChannel',
        value: false
      }, {
        name: 'terminal.fourthChannel',
        value: false
      }, {
        name: 'terminal.fifthChannel',
        value: false
      }, {
        name: 'terminal.sixthChannel',
        value: false
      }, {
        name: 'terminal.seventhChannel',
        value: false
      },
      {
        name: 'terminal.eighthChannel',
        value: false
      }
      ],
      isBan: false,
      cardLoading: false,
      powerFourth: 1,
      isMuti: true,
      dialogVisible: false,
      controlType: ''
    }
  },
  methods: {
    allOpen(type, isOpen) {
      if (type == 'power') {
        this.powerList.forEach((ele) => {
          ele.value = isOpen;
        })
      } else if (type == 'card') {
        this.cardList.forEach((ele) => {
          ele.value = isOpen;
        })
      }
    },
    async getCardStatus() {
      this.cardLoading = true;
      this.powerLoading = true;
      sendCommandKp('multiple', this.dcInfoCache, "get", {
        methodName: "getMultiRelay",
        methodParams: {}
      });
      this.myWebSocket.onmessage = (val) => {
        let res = JSON.parse(val.data);
        if (res.type == 'invoke_method' && res.data.uri == "getMultiRelay") {
          let data = JSON.parse(res.data.response);
          let status = data.status.toString(2);
          while (status.length < 12) {
            status = '0' + status;
          }
          let kpbPower_status = status.slice(0, 1)
          let power_status = status.slice(0, 4);
          let card_status = status.slice(4, status.length);
          this.powerFourth = status[status.length - 1];
          //let card_status_resver = card_status.resver()
          for (let i = 0; i < card_status.length; i++) {
            this.cardList[7 - i].value = card_status[i] == 1 ? true : false;
          }
          for (let i = power_status.length - 1; i >= 1; i--) {
            this.powerList[3 - i].value = power_status[i] == 1 ? true : false; //实际上有四路，只设置前三路
          }
          this.kpbPower[0].value = kpbPower_status == 1 ? true : false; //
          this.cardLoading = false;
        }
      }
    },
    async sendToDevice() {
      let res = '';
      let car_res = '';
      let carList = this.cardList.reverse();
      let powList = this.powerList.reverse();
      carList.forEach(ele => {
        car_res = car_res + (ele.value === false ? '0' : '1');
      })
      powList.forEach(ele => {
        res = res + (ele.value == false ? '0' : '1');
      })

      this.cardList.reverse();
      this.powerList.reverse();
      // res = this.powerFourth + res;
      res = (this.kpbPower[0].value ? 1 : 0) + res;

      if (this.currentDetail.run_state) {
        sendCommandKp('multiple', this.dcInfoCache, "set", {
          methodName: "setPx30Relay",
          methodParams: { status: parseInt(res, 2) }
        });
        sendCommandKp('multiple', this.dcInfoCache, "set", {
          methodName: "setMultiRelay",
          methodParams: { status: parseInt(car_res, 2) }
        });
      }
    },
    closeFormDialog(isConfirm) {
      if (isConfirm) {
        console.log('确定....')
        let status = (this.controlType == 'open' ? parseInt('11111111', 2) : parseInt('00000000', 2));
        this.$http.post('/admin/Command/deviceCommand', {
          commands_info: uriEncode([{
            device_id: this.currentDetail.id,
            sn: this.currentDetail.sn,
            msg: {
              id: this.currentDetail.id,
              data: {
                value: status
              },
              type: 'set_multi_relay'
            }
          }])
        }, data => {
          if (data.length == 0) {
            this.$msg({
              type: 'success',
              message: this.$t('terminal.opOk')
            })
          }
        });
      }
      this.dialogVisible = false;
      this.controlType = '';
    },
    controlNoVersion(val) {
      this.controlType = val;
      this.dialogVisible = true;
    },
    getRelayByOld() {
      this.$http.post('/admin/Command/deviceCommand', {
        commands_info: uriEncode([{
          device_id: this.currentDetail.id,
          sn: this.currentDetail.sn,
          msg: {
            id: this.currentDetail.id,
            sn: this.currentDetail.sn,
            groupName: this.currentDetail.group_id,
            type: 'getMultiRelay'
          }
        }])
      });

    },
    refreshStatus() {
      this.getCardStatus();
    }
  },
  created() {
    this.dcInfoCache = [{
      id: this.currentDetail.id,
      sn: this.currentDetail.sn,
      type_id: this.currentDetail.type_id,
      name: this.currentDetail.name,
      cache: {}
    }];
    let version = this.currentDetail.system_version;
    let versionNumber = (version == null ? null : version.slice(version.length - 3, version.length));
    console.log(versionNumber)
    if (this.currentDetail.run_state && versionNumber > 218) {
      this.isBan = false;
      this.isMuti = true;
      this.getCardStatus();
    } else if (this.currentDetail.run_state && versionNumber <= 218) {
      this.isBan = true;
      this.isMuti = false;
      this.getRelayByOld();
    }
  },
  computed: {
    myWebSocket() {
      return this.$store.getters.myWebSocket;
    },
  },
}
</script>

<style lang="scss" scoped>
.relay-control-detail {
  width: 100%;
  height: 100%;

  .single {
    height: 180px;
    width: 320px;
    margin: 120px auto;
    font-size: 18px;
    //border: 1px solid grey;
    padding: 5px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .multi {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
  .content {
    width: 60%;
    max-width: 750px;
    height: calc(100% - 15px);
    margin: 10px auto;
    border: 1px solid #cfd5d8;
    overflow-y: auto;

    .power {
      width: 100%;
      height: 200px;
    }

    .head {
      width: calc(100% - 40px);
      height: 40px;
      padding: 0 20px 0 20px;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .main {
      margin: 0 auto;
      width: 80%;
      height: 140px;
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;

      .item {
        width: 50%;
        height: 70px;
        text-align: center;
        display: flex;
        align-items: center;
        padding-left: 20px;
        .contents {
          display: flex;
          align-items: center;
          justify-content: space-around;
          width: 240px;
          .name {
            width: 120px;
            white-space: nowrap;
          }
        }
      }
    }

    .card-main {
      height: 280px;
    }

    .button {
      float: right;
      margin-right: 50px;
    }

    .refresh {
      margin-left: 50px;
    }
  }
}
</style>
